import { some } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';

import PageSpinner from 'App/components/PageSpinner';
import useFetchAssessmentSettings from '../hooks/useFetchAssessmentSettings';
import AssessmentManagerQuestionsForm from './AssessmentManagerQuestionsForm';
import useFetchAssessmentQuestionLinks from './hooks/useFetchAssessmentQuestionLinks';
import useFetchAssessmentQuestions from './hooks/useFetchAssessmentQuestions';
import useFetchAssessmentRiskOptions from './hooks/useFetchAssessmentRiskOptions';

const AssessmentManagerQuestions = () => {
    const { categoryId, assessmentId } = useParams();
    const { data: assessment, isLoading } = useFetchAssessmentSettings(categoryId, assessmentId);
    const { data: assessmentRiskOptions, isLoading: isRiskOptionsLoading } =
        useFetchAssessmentRiskOptions(assessmentId);
    const { data: assessmentQuestions, isFetching: isQuestionsFetching } = useFetchAssessmentQuestions(assessmentId);
    const { data: questionLinks, isFetching: isQuestionLinksFetching } = useFetchAssessmentQuestionLinks(assessmentId);

    if (some([isLoading, isRiskOptionsLoading, isQuestionsFetching, isQuestionLinksFetching])) {
        return <PageSpinner />;
    }

    return (
        <AssessmentManagerQuestionsForm
            assessment={assessment}
            assessmentRiskOptions={assessmentRiskOptions}
            assessmentQuestions={assessmentQuestions}
            questionLinks={questionLinks}
        />
    );
};

export default AssessmentManagerQuestions;
